<script lang="ts" setup>
  import { APP_STORE } from '@/constants/url'

  defineProps<{
    store: 'Android' | 'iOS'
  }>()
</script>

<template>
  <a v-if="store === 'Android'" :href="APP_STORE.GOOGLE_PLAY" aria-label="Get it on Google Play" target="_blank">
    <icon-appstore-download-google alt="Get it on Google Play" height="52" width="181" />
  </a>
  <a v-if="store === 'iOS'" :href="APP_STORE.APPLE_STORE" aria-label="Download on the App Store" target="_blank">
    <icon-appstore-download-apple alt="Download on the App Store" height="52" width="181" />
  </a>
</template>
